import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { GrupoUsuario } from '../types';

import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryGrupoUsuarioPadrao() {
    const { id } = useParams();
    const requestListagem = useRequestListagem();

    const configRequestOptions: RequestOptionsType = {
        url: '/gestao/grupousuario',
        filter: [{ property: 'fgPadraoFranqueado', operator: 'eq', value: true }],
        sort: [{ property: 'idGrupoUsuario', direction: 'DESC' }],
    };

    return useQuery<GrupoUsuario[]>(
        ['queryGrupoUsuarioPadrao', configRequestOptions],
        () => requestListagem(configRequestOptions).then((res) => res.data.data),
        {
            enabled: !id,
            cacheTime: 0,
        },
    );
}
